import { Center, Text, Box } from '@chakra-ui/react';
import type { PageProps } from './RegularButton';

const PageHeader = ({ title }: PageProps) => (
  <Box width={'100%'} className="noScroll">
    <Center>
      <Text
        color={'white'}
        fontSize={'2xl'}
        justifyContent={'center'}
        margin={'auto'}
        paddingTop={'5'}
        paddingBottom={'5'}
        paddingLeft={'10'}
        paddingRight={'10'}
        as={'b'}
        textAlign={'center'}
        lineHeight={'1.2'}
      >
        {title}
      </Text>
    </Center>
  </Box>
);

export default PageHeader;
